module.exports = __webpack_public_path__ + "static/media/iconChatSmile.67a012eb.svg";